import findClosestGradeBand from "@/utils/findClosestGradeBand";

import type { GradeBandKey } from "@/constants/GradeAndLexileLevels";
import type { ArticleLevel } from "@/types/models/ArticleLevel.interface";
import type { ContentLevel } from "@/types/models/ContentLevel.interface";

function getBestLanguageMatch<
  T extends { grade_band: GradeBandKey } = ContentLevel,
>(
  filteredByLanguageList: T[],
  currentLevel: ArticleLevel | undefined,
): T | undefined {
  if (filteredByLanguageList.length) {
    const possibleGradeBands = filteredByLanguageList.map(
      (level) => level.grade_band,
    );
    const closestLanguageMatch = findClosestGradeBand(
      currentLevel?.grade_band,
      possibleGradeBands,
    );
    return filteredByLanguageList.find(
      (level: T) => level.grade_band === closestLanguageMatch,
    );
  }
  return undefined;
}

export default getBestLanguageMatch;
